"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KpiChild = exports.KpiTheme = void 0;
const kpi_element_1 = require("client/components/kpi-header/kpi-element");
const react_1 = require("react");
const React = require("react");
require("./kpi-child.less");
var KpiTheme;
(function (KpiTheme) {
    KpiTheme["Approved"] = "approved";
    KpiTheme["Margin"] = "margin";
    KpiTheme["Normal"] = "normal";
    KpiTheme["Profit"] = "profit";
})(KpiTheme = exports.KpiTheme || (exports.KpiTheme = {}));
class KpiChild extends react_1.Component {
    render() {
        const { children, label = "", name = "", performance = 0, subLabel = "", theme } = this.props;
        if (children) {
            return React.createElement("div", { className: "kpi-child" }, children);
        }
        const hasMarginLeft = theme === KpiTheme.Margin ? "has-margin-left" : "";
        const hasMarginTop = theme === KpiTheme.Approved ? "has-margin-top" : "";
        return (React.createElement("div", { className: `kpi-child ${hasMarginTop}` },
            React.createElement("div", { className: "kpi-child__label" }, label),
            React.createElement("div", { className: "kpi-child__detail" },
                theme && this.renderPerformance(theme, performance),
                React.createElement("div", { className: `kpi-child__info ${hasMarginLeft}` },
                    React.createElement("div", { className: "kpi-child__name" }, name),
                    React.createElement("div", { className: `kpi-child__id ${theme}` }, subLabel)))));
    }
    renderPerformance(theme, performance) {
        switch (theme) {
            case KpiTheme.Approved:
                return this.renderApproved(performance);
            case KpiTheme.Margin:
                return this.renderMargin(performance);
            case KpiTheme.Normal:
                return this.renderNormal(performance);
            case KpiTheme.Profit:
                return this.renderProfit(performance);
            default:
                return null;
        }
    }
    renderApproved(performance) {
        return (React.createElement("div", { className: "kpi-child__approved" },
            React.createElement(kpi_element_1.KpiElement, { check: true, element: {
                    color: kpi_element_1.KPIElementColor.Green,
                    label: "",
                    size: kpi_element_1.KPIElementSize.Medium,
                    value: 0
                } }),
            React.createElement("div", { className: "kpi-child__approved-orders" },
                React.createElement("span", { className: "kpi-child__number" }, Number(performance).toLocaleString()),
                React.createElement("span", { className: "kpi-child__orders" }, "ORDERS"))));
    }
    renderMargin(performance) {
        return (React.createElement("div", { className: "kpi-child__margin" },
            React.createElement("div", { className: "kpi-child__margin-bar" },
                React.createElement("div", { className: "kpi-child__indicator", style: { width: (performance * 150) / 100 } })),
            React.createElement("span", { className: "kpi-child__number" }, Number(performance).toLocaleString()),
            React.createElement("span", { className: "kpi-child__unit kpi-child__percent" }, "%")));
    }
    renderNormal(performance) {
        return (React.createElement("div", { className: "kpi-child__normal" },
            React.createElement("span", { className: "kpi-child__number no-margin" }, Number(performance).toLocaleString())));
    }
    renderProfit(performance) {
        return (React.createElement("div", { className: "kpi-child__profit" },
            React.createElement("span", { className: "kpi-child__unit" }, "$"),
            React.createElement("span", { className: "kpi-child__number" }, Number(performance).toLocaleString())));
    }
}
exports.KpiChild = KpiChild;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/kpi-header/kpi-child/kpi-child.tsx
// module id = 3463
// module chunks = 0